// libraries
import * as Rails from "@rails/ujs"
import * as Turbolinks from "turbolinks"

// polyfills
import "@stimulus/polyfills"
import "core-js/stable" // FIXME: musn't import everything!
import "regenerator-runtime/runtime" // FIXME: needed (?)
import "whatwg-fetch"

// trackers
import "../../lib/google_analytics"

// controllers
import { Application } from "stimulus"
import CarouselController from "../../controllers/carousel_controller"
import ClientExpoController from "../../controllers/client_expo_controller"
import ScrollerController from "../../controllers/scroller_controller"
import FlashMessageController from "../../controllers/flash_message_controller"
import ZoomOverController from "../../controllers/zoom_over_controller"

Rails.start()
Turbolinks.start()

// stimulus
const application = Application.start()
application.register("carousel", CarouselController)
application.register("client-expo", ClientExpoController)
application.register("scroller", ScrollerController)
application.register("flash-message", FlashMessageController)
application.register("zoom-over", ZoomOverController)

ga("create", "UA-107300824-6", "auto")
ga("send", "pageview")
